module.exports = __webpack_public_path__ + "static/img/example_label.9ce12c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010230/example_label.png
// module id = RacK
// module chunks = 10